export enum EDeliveryRequestType {
  Create = "CREATE",
  Transfer = "TRANSFER",
  Update = "Update",
  Disclosure = "DISCLOSURE",
  Undisclosure = "UNDISCLOSURE",

  Close = "CLOSE",
  Reopen = "REOPEN",
  ExtensePeriod = "EXTENSEPERIOD",
}
